<template>
    <div class="similar-image-review-decision-panel">
        <el-radio-group class="similar-image-review-decision-panel__group" :value="value" size="mini" @input="$emit('input', $event)">
            <el-radio-button label="pending">待定</el-radio-button>
            <el-radio-button label="confirmed-valid">确认有效</el-radio-button>
            <el-radio-button label="confirmed-rejected">确认排除</el-radio-button>
        </el-radio-group>
        <el-button class="similar-image-review-decision-panel__action" size="mini" type="primary" :loading="saving" @click="$emit('save')">
            保存
        </el-button>
        <el-button class="similar-image-review-decision-panel__action" size="mini" @click="$emit('toggle-history')">
            {{ historyVisible ? "收起历史" : "查看历史" }}
        </el-button>
    </div>
</template>

<script>
export default {
    name: "SimilarImageReviewDecisionPanel",
    props: {
        value: {
            type: String,
            default: "pending",
        },
        saving: {
            type: Boolean,
            default: false,
        },
        historyVisible: {
            type: Boolean,
            default: false,
        },
    },
};
</script>

<style scoped>
.similar-image-review-decision-panel {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    min-width: 196px;
}

.similar-image-review-decision-panel__group {
    width: 100%;
}

.similar-image-review-decision-panel__action {
    width: 100%;
    height: 28px;
    line-height: 26px;
    padding: 0 10px;
    text-align: center;
    border-radius: 6px;
    font-weight: 500;
}
</style>
